import ApiService from './api.service'

const ExportService = {    
  getExports(idProject, idExportProvider, exportTime) {
    return ApiService.get('/api/export', {
      params: {
        IdProject: idProject,
        IdExportProvider: idExportProvider,
        ExportTime: exportTime,
      }
    })
  },

  createExportProvider(idSprExportProviderType, idProject, exportMode, exportTime, countDaysOfStatements, endpoint, login, password, settings, energyMeterTypePublicCodes) {
    let provider = {
      idSprExportProviderType: idSprExportProviderType,
      idProject: idProject,
      exportMode: exportMode,
      exportTime: exportTime,
      countDaysOfStatements: countDaysOfStatements,
      endpoint: endpoint,
      login: login,
      password: password,
      settings: settings,
      energyMeterTypePublicCodes: energyMeterTypePublicCodes
    }
    return ApiService.post(`/api/export/provider`, provider)
  },

  updateExportProvider(id, exportMode, exportTime, countDaysOfStatements, endpoint, login, password, settings, energyMeterTypePublicCodes) {
    let provider = {
      id: id,
      exportMode: exportMode,
      exportTime: exportTime,
      countDaysOfStatements: countDaysOfStatements,
      endpoint: endpoint,
      login: login,
      password: password,
      settings: settings,
      energyMeterTypePublicCodes: energyMeterTypePublicCodes
    }
    return ApiService.put(`/api/export/provider`, provider)
  },

  deleteExportProvider(id) {
    return ApiService.delete(`/api/export/provider/${id}`)
  },

  startManual(id, manualParams) {
    let request = {
      id: id,
      manualParams: manualParams      
    }
    return ApiService.put(`/api/export/provider/start-manual/`, request)
  },

  getExportProviders(idProject) {
    return ApiService.get('/api/export/provider', {
      params: {
        IdProject: idProject,
      }
    })
  },

  getExportProvider(id) {
    return ApiService.get(`/api/export/provider/${id}`)
  },

  ////////////////////////////////////////////

  getExportProviderMeterSettings(idProject, energyMeterTypesPublicCodes, meterSerialNumber, notRegisterAisCra, page, count) {
    return ApiService.get('/api/export/provider-meter-settings', {
      params: {
        IdProject: idProject,
        EnergyMeterTypesPublicCodes: energyMeterTypesPublicCodes,
        MeterSerialNumber: meterSerialNumber,
        NotRegisterAisCra: notRegisterAisCra,
        Page: page,
        Count: count
      }
    })
  },

  getExportProviderTypes() {
    return ApiService.get('/api/export/provider-types')
  },

  getExportProviderLogs(idProvider, idExport, idMeter, meterSerialNumber, status, exportProviderTypePublicCode, page, count) {
    return ApiService.get('/api/export/logs', {
      params: {
        IdProvider: idProvider,
        IdExport: idExport,
        IdMeter: idMeter,
        MeterSerialNumber: meterSerialNumber,
        Status: status,
        ExportProviderTypePublicCode: exportProviderTypePublicCode,
        Page: page,
        Count: count
      }
    })
  },

}

export default ExportService